export enum AchSetup {
	None = 0,
	GlobalLevel = 1,
	SiteLevel = 2,
}

export const AchSetupArray = [
	{
		Id: 0,
		Description: 'None',
	},
	{
		Id: 1,
		Description: 'Global Level',
	},
	{
		Id: 2,
		Description: 'Site Level',
	},
];
